module.exports = __webpack_public_path__ + "media/pricing/DigitalProduct-2793d5ac.png";